import { useState } from 'react';
import "./Classes.css";

const Classes = () => {
    const [activity, setActivity] = useState('All Class');

    // clases categories
    const categories = {
        'Painting': [
            { id: 1, imageUrl: '/images/paint1.png' },
            { id: 2, imageUrl: '/images/paint2.png' },
            { id: 2, imageUrl: '/images/paint3.png' },
        ],
        'Play': [
            { id: 1, imageUrl: '/images/play1.png' },
            { id: 2, imageUrl: '/images/play2.png' },
        ],
        'Study': [
            { id: 1, imageUrl: '/images/study1.png' },
            { id: 2, imageUrl: '/images/study2.png' },
        ],
    };

    // merge all array
    const allClassImages = [
        ...categories['Painting'],
        ...categories['Play'],
        ...categories['Study'],
    ];

    // Handle category selection
    const classClick = (category) => {
        setActivity(category);
    };

    return (
        <>
            <div className="container mt-">
                <div className="row">
                    <div className="classes-button">
                        {['All Class', 'Painting', 'Play', 'Study'].map((category) => (
                            <button
                                key={category}
                                onClick={() => classClick(category)}
                                className={`btn btn-primary ${activity === category ? 'active' : ''}`}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="row">
                    {/* ---------------------displayling----------------------- */}
                    {activity === 'All Class'
                        ? allClassImages.map((card) => (
                            <div className="class-card col-xl-4 col-lg-4 col-md-6 col-12 mb-4" key={card.id}>
                                <div className="card custom-card h-100">
                                    <img src={card.imageUrl} className="card-img-top" alt="Card image" />
                                </div>
                            </div>
                        ))
                        : categories[activity].map((card) => (
                            <div className="class-card col-xl-4 col-lg-4 col-md-6 col-12 mb-4" key={card.id}>
                                <div className="card custom-card h-100">
                                    <img src={card.imageUrl} className="card-img-top" alt="Card image" />
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    );
};

export default Classes;